import { httpClient } from "@/services";

export default {
	state: {
		trailerNotesFilter: null,
		trailerNotesList: []
	},
	mutations: {
		updateTrailerNotes(state, { filter, list }) {
			state.trailerNotesFilter = filter;
			state.trailerNotesList = list;
		}
	},
	actions: {
		async onTrailerNotes({ commit, dispatch }, trailerId) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/trailers/notes/${ trailerId }`);
				if (data && !data.status) {
					commit('updateTrailerNotes', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onTrailerNotesCreate({ dispatch }, { trailerId, values }) {
			dispatch("actionPreloader", true);
			const { id, notes } = values;
			const url = id ? `/trailers/notes/${ id }/update` : `/trailers/notes/${ trailerId }/store`;
			const message = id ? "Updated notes item" : "Created notes item";

			try {
				const { data } = await httpClient.post(url, { notes });
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message });
					await dispatch('onTrailerNotes', trailerId);
					dispatch("actionPreloader", false);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onTrailerNotesListFilter({ commit }, { id, filters }) {
			try {
				const { data } = await httpClient.post(`/trailers/notes/${ id }`, filters);
				if (data && !data.status) {
					commit('updateTrailerNotes', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrailerNotesRemove({ dispatch }, { id, trailerId }) {
			const { data } = await httpClient.delete(`/trailers/notes/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove notes item" });
				dispatch('onTrailerNotes', trailerId);
			}
		}
	},
	getters: {
		trailerNotesFilter: s => s.trailerNotesFilter,
		trailerNotesList: s => s.trailerNotesList
	}
};
